module.exports = __webpack_public_path__ + "media/images/low_stock_label_off-9e047e7226248acc2a0a17bbf9678b90.png";